
















/**
 * This component was taken from https://codepen.io/poziomq/pen/ozaYKK
 * and ported to TS
 * */
import Vue from 'vue';

export default Vue.extend({
  name: 'HPacmanLoading',
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
  },
});
